// SearchPage Styles Module
export const searchPageStyles = {
  // Main container styles
  mainContainer: {
    minHeight: '100vh',
    height: '100vh',
    overflow: 'auto',
    padding: 0,
    background: 'var(--color-bg)',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    scrollBehavior: 'smooth',
  },

  contentWrapper: {
    flex: 1,
    width: '100%',
    maxWidth: 900,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    paddingBottom: '120px',
  },

  // Top search form styles
  topSearchForm: {
    width: '100%',
    maxWidth: '100%',
    margin: '0',
    background: 'var(--color-bg-card)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 1px 3px var(--color-shadow)',
    zIndex: 20,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    transition: 'all 0.2s cubic-bezier(.4,0,.2,1)',
    borderBottom: '1px solid var(--color-border)',
  },

  searchInputContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: '600px',
    margin: '0 auto',
    gap: '12px',
  },

  searchInput: {
    flex: 1,
    borderRadius: 8,
    border: '1px solid var(--color-border)',
    background: 'var(--color-bg-card)',
    color: 'var(--color-text)',
    outline: 'none',
    transition: 'all 0.2s cubic-bezier(.4,0,.2,1)',
    boxShadow: '0 1px 2px var(--color-shadow)',
  },

  searchButton: {
    background: 'var(--color-primary)',
    border: 'none',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: '500',
    color: 'var(--color-bg-card)',
    transition: 'all 0.2s cubic-bezier(.4,0,.2,1)',
    whiteSpace: 'nowrap',
  },

  // Header styles
  headerButtons: {
    position: 'fixed',
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    zIndex: 3000,
    transition: 'all 0.2s cubic-bezier(.4,0,.2,1)',
  },

  loadingSpinner: {
    width: '50%',
    height: '50%',
    border: '2px solid var(--color-primary)',
    borderTop: '2px solid transparent',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    transition: 'all 0.2s cubic-bezier(.4,0,.2,1)',
  },

  profileButton: {
    borderRadius: '50%',
    background: 'var(--color-primary)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontWeight: 'bold',
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'all 0.2s cubic-bezier(.4,0,.2,1)',
  },

  loginButton: {
    background: 'var(--color-primary)',
    color: 'var(--color-bg-card)',
    fontWeight: 700,
    border: 'none',
    borderRadius: '8px',
    boxShadow: '0 2px 8px var(--color-shadow)',
    opacity: 1,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'all 0.2s cubic-bezier(.4,0,.2,1)',
    cursor: 'pointer',
    height: '40px',
    whiteSpace: 'nowrap',
  },

  // Search type tabs styles
  searchTypeTabsContainer: {
    width: '100%',
    maxWidth: '900px',
    margin: '0 auto',
    padding: '0 16px',
    background: 'var(--color-bg-card)',
    borderBottom: '1px solid var(--color-border)',
    boxShadow: '0 1px 3px var(--color-shadow)',
  },

  searchTypeTabs: {
    display: 'flex',
    overflowX: 'auto',
    gap: 0,
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
  },

  searchTypeTab: {
    padding: '12px 20px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    whiteSpace: 'nowrap',
    transition: 'all 0.2s ease',
    minWidth: 'fit-content',
  },

  // Blocked message styles
  blockedMessage: {
    width: '100%',
    maxWidth: '600px',
    margin: '16px auto',
    padding: '16px 20px',
    background: 'var(--color-error-bg)',
    border: '1px solid var(--color-error)',
    borderRadius: 8,
    color: 'var(--color-error)',
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: '500',
    boxShadow: '0 2px 4px var(--color-shadow)',
  },

  // Main content area styles
  mainContent: {
    flex: 1,
    display: 'flex',
    width: '100%',
    height: 'auto',
    overflow: 'visible',
    position: 'relative',
    padding: '24px 0',
    gap: '24px',
  },

  // AI Overview and Chat section styles
  aiOverviewChatSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    background: 'var(--color-bg-card)',
    borderRadius: 8,
    boxShadow: '0 2px 8px var(--color-shadow)',
    overflow: 'hidden',
    border: '1px solid var(--color-border)',
    transition: 'all 0.3s ease',
  },

  aiOverviewHeader: {
    padding: '16px 24px',
    borderBottom: '1px solid var(--color-border)',
    background: 'var(--color-bg)',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },

  aiOverviewIcon: {
    background: 'var(--color-primary)',
    padding: 8,
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  aiOverviewTitle: {
    margin: 0,
    color: 'var(--color-text)',
    fontSize: '16px',
    fontWeight: '600',
  },

  aiOverviewSubtitle: {
    margin: '2px 0 0',
    color: 'var(--color-secondary)',
    fontSize: '12px',
  },

  // Chat messages container
  chatMessagesContainer: {
    flex: 1,
    overflowY: 'auto',
    minHeight: 0,
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    scrollBehavior: 'smooth',
  },

  // Web search card styles
  webSearchCard: {
    background: 'var(--color-bg-card)',
    borderRadius: 8,
    boxShadow: '0 2px 8px var(--color-shadow)',
    border: '1px solid var(--color-border)',
    transition: 'all 0.3s ease',
  },

  webSearchHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    marginBottom: 20,
    borderBottom: '1px solid var(--color-border)',
    padding: '20px 20px 16px 20px',
  },

  webSearchIcon: {
    background: 'var(--color-primary)',
    padding: 12,
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  webSearchTitle: {
    margin: 0,
    color: 'var(--color-text)',
    fontSize: '18px',
    fontWeight: '600',
  },

  webSearchSubtitle: {
    margin: '4px 0 0',
    color: 'var(--color-secondary)',
    fontSize: '14px',
  },

  // Chat input styles
  chatInputAnchor: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 200,
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'none',
  },

  chatInputInner: {
    width: '100vw',
    maxWidth: '100vw',
    margin: 0,
    padding: 0,
    pointerEvents: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  chatInputBox: {
    padding: '20px',
    background: 'var(--color-bg-card)',
    borderTop: '1px solid var(--color-border)',
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    boxShadow: '0 -2px 8px var(--color-shadow)',
  },

  // File preview styles
  filePreview: {
    marginBottom: 12,
  },

  fileItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    background: 'var(--color-bg)',
    padding: 8,
    borderRadius: 4,
    marginBottom: 4,
    border: '1px solid var(--color-border)',
  },

  fileRemoveButton: {
    background: 'none',
    border: 'none',
    color: 'var(--color-primary)',
    cursor: 'pointer',
    padding: 2,
    fontSize: '12px',
  },

  // Input controls styles
  inputControls: {
    position: 'relative',
  },

  inputControlsRow: {
    display: 'flex',
    gap: 12,
    alignItems: 'flex-end',
  },

  uploadButton: {
    padding: '10px 12px',
    borderRadius: 6,
    background: 'var(--color-text)',
    color: 'var(--color-bg-card)',
    border: 'none',
    cursor: 'pointer',
    fontSize: 12,
    transition: 'all 0.2s ease',
  },

  appLauncherButton: {
    padding: '10px 12px',
    borderRadius: 6,
    background: 'var(--color-primary)',
    color: 'var(--color-bg-card)',
    border: 'none',
    cursor: 'pointer',
    fontSize: 16,
    transition: 'all 0.2s ease',
    marginRight: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '40px',
    height: '40px',
  },

  messageTextarea: {
    flex: 1,
    padding: '12px 16px',
    border: '1px solid var(--color-border)',
    borderRadius: 6,
    resize: 'none',
    minHeight: 44,
    maxHeight: 120,
    fontSize: 14,
    background: 'var(--color-bg)',
    transition: 'all 0.2s ease',
    outline: 'none',
  },

  sendButton: {
    background: 'var(--color-primary)',
    color: 'var(--color-bg-card)',
    border: 'none',
    padding: '10px 16px',
    borderRadius: 6,
    cursor: 'pointer',
    fontSize: 12,
    fontWeight: '500',
    transition: 'all 0.2s ease',
  },

  // App launcher dropdown styles
  appLauncherDropdown: {
    position: 'absolute',
    bottom: '110%',
    left: 0,
    width: 320,
    maxHeight: 400,
    overflowY: 'auto',
    background: 'var(--color-bg-card)',
    border: '2px solid var(--color-primary)',
    borderRadius: 12,
    boxShadow: '0 8px 24px var(--color-shadow)',
    zIndex: 10000,
    marginBottom: 8,
  },

  appLauncherHeader: {
    padding: '12px 16px',
    borderBottom: '1px solid var(--color-border)',
    background: 'var(--color-bg)',
    borderRadius: '10px 10px 0 0',
  },

  appLauncherTitle: {
    margin: 0,
    color: 'var(--color-text)',
    fontSize: 16,
  },

  appLauncherContent: {
    padding: 8,
  },

  appButton: {
    width: '100%',
    padding: 12,
    margin: '4px 0',
    background: 'var(--color-bg-card)',
    border: '1px solid var(--color-border)',
    borderRadius: 8,
    cursor: 'pointer',
    textAlign: 'left',
    color: 'var(--color-text)',
  },

  appButtonTitle: {
    fontWeight: 'bold',
    color: 'var(--color-text)',
  },

  appButtonDescription: {
    fontSize: 12,
    color: 'var(--color-secondary)',
  },

  // Suggestion styles
  suggestionsList: {
    position: 'absolute',
    top: '100%',
    left: 0,
    zIndex: 10,
    minWidth: '100%',
    background: 'var(--color-bg)',
    borderRadius: 6,
    border: '1px solid var(--color-border)',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    marginTop: 4,
    padding: '8px 0',
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    alignItems: 'stretch',
  },

  suggestionButton: {
    padding: '8px 16px',
    fontSize: 14,
    background: 'var(--color-bg)',
    color: 'var(--color-text)',
    border: 'none',
    borderBottom: '1px solid #f8f9fa',
    borderRadius: 0,
    cursor: 'pointer',
    textAlign: 'left',
    width: '100%',
    transition: 'background 0.2s ease',
  },

  suggestionBar: {
    marginTop: 12,
    padding: 12,
    background: 'var(--color-bg)',
    borderRadius: 6,
    border: '1px solid #e9ecef',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    justifyContent: 'flex-start',
  },

  categoryButton: {
    padding: '6px 12px',
    fontSize: 12,
    background: 'var(--color-bg)',
    color: 'var(--color-text)',
    border: '1px solid #dee2e6',
    borderRadius: 4,
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'all 0.2s ease',
  },

  // Utility styles
  fullScreenButton: {
    position: 'absolute',
    top: 16,
    right: 16,
    zIndex: 200,
    background: 'var(--color-bg-card)',
    color: 'var(--color-primary)',
    border: '1px solid var(--color-border)',
    borderRadius: 6,
    padding: '6px',
    fontSize: 18,
    fontWeight: 600,
    cursor: 'pointer',
    boxShadow: '0 2px 8px var(--color-shadow)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16,
    padding: '40px 20px',
    textAlign: 'center',
  },

  loadingSpinnerLarge: {
    width: '32px',
    height: '32px',
    borderWidth: '3px',
  },

  loadingText: {
    fontWeight: '600',
    color: 'var(--color-text)',
    fontSize: '18px',
  },

  loadingSubtext: {
    color: 'var(--color-secondary)',
    fontSize: '14px',
  },

  // Responsive styles
  responsiveStyles: `
    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateX(-50%) translateY(10px);
      }
      to {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
      }
    }
    
    @media (max-width: 900px) {
      .search-main-content {
        flex-direction: column !important;
        padding: 16px !important;
        gap: 16px !important;
      }
      .ai-overview-chat-section {
        margin: 0 !important;
        border-radius: 8px !important;
        min-height: auto !important;
        height: auto !important;
      }
      .web-search-card {
        max-width: 100% !important;
        min-width: 0 !important;
        border-radius: 8px !important;
        position: static !important;
        order: 1 !important;
      }
    }

    @media (max-width: 768px) {
      html, body, #root {
        height: 100vh !important;
        overflow-x: hidden !important;
      }
      
      .search-main-content, .ai-overview-chat-section, .web-search-card {
        max-width: 100vw !important;
        width: 100vw !important;
        overflow-x: hidden !important;
      }
      
      /* Single scroll for mobile - disable individual card scrolling */
      .search-main-content {
        padding-bottom: 140px !important;
        overflow: visible !important;
      }
      
      .ai-overview-chat-section {
        min-width: 0 !important;
        max-width: 100vw !important;
        width: 100vw !important;
        box-sizing: border-box !important;
        overflow: visible !important;
      }
      
      .chat-messages-container {
        overflow: visible !important;
        max-height: none !important;
        height: auto !important;
      }
      
      .web-search-card {
        min-width: 0 !important;
        max-width: 100vw !important;
        width: 100vw !important;
        box-sizing: border-box !important;
        overflow: visible !important;
      }
      
      /* Ensure main container handles all scrolling */
      .search-main-container {
        overflow-y: auto !important;
        overflow-x: hidden !important;
        height: 100vh !important;
        position: relative !important;
      }
      
      .mobile-chat-input-anchor {
        position: fixed !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        z-index: 9999 !important;
        width: 100vw !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        background: transparent !important;
        pointer-events: none;
        /* Ensure it stays at bottom even with dynamic viewport */
        position: fixed !important;
        bottom: env(safe-area-inset-bottom, 0) !important;
      }
      .mobile-chat-input-inner {
        width: 100vw !important;
        max-width: 100vw !important;
        margin: 0 !important;
        padding: 0 !important;
        pointer-events: auto;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .mobile-chat-input-box {
        padding: 12px 8px 16px 8px !important;
        background: var(--color-bg-card) !important;
        border-top: 1px solid var(--color-border) !important;
        border-bottom-left-radius: 8px !important;
        border-bottom-right-radius: 8px !important;
        box-shadow: 0 -2px 8px var(--color-shadow) !important;
        width: 100vw !important;
        max-width: 100vw !important;
        box-sizing: border-box !important;
        position: fixed !important;
        bottom: env(safe-area-inset-bottom, 0) !important;
        left: 0 !important;
        right: 0 !important;
      }
      
      /* Ensure typing indicator doesn't overlap with chat input */
      .mobile-chat-input-anchor {
        margin-bottom: 0 !important;
      }
      /* Move headerButtons (login button) down on mobile */
      .header-buttons {
        top: 70px !important;
        right: 16px !important;
      }
      /* Hide header login/profile button on mobile */
      .header-buttons {
        display: none !important;
      }
    }
  `,
};

// Helper function to get responsive styles
export const getResponsiveStyles = () => searchPageStyles.responsiveStyles; 